import {Component, h, Prop, Element, Host, Event, EventEmitter} from '@stencil/core';
import {NestModalOptions} from "./nest-modal.interfaces";

@Component({
  tag: 'nest-modal',
  styleUrl: 'nest-modal.scss',
  shadow: false,
})
export class NestModal {
  @Element() element!: HTMLElement

  @Prop() data: NestModalOptions;

  @Event() nestClose: EventEmitter<void>;

  private headerSlot: HTMLElement;
  private footerSlot: HTMLElement;

  close() {
    this.nestClose.emit()
  }

  componentWillLoad() {
    this.headerSlot =  this.element.querySelector("[slot='nest-modal-header']")
    this.footerSlot =  this.element.querySelector("[slot='nest-modal-footer']")
  }

  render() {
    return (
      <Host
        aria-modal="true"
        tab-index="-1"
        class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 bottom-0 bg-black/50 z-50 flex justify-center items-center w-full md:inset-0 max-h-full"
      >
        <div class="relative p-4 w-full max-w-xl max-h-full">
          <div class="relative bg-white rounded-lg shadow mx-auto">
            <nest-icon
              name='close-dashboard'
              class="z-50 hover:cursor-pointer hover:fill-blue-600 absolute top-0 right-0 w-8 h-8 mt-4 mr-3"
              onClick={() => this.close()}
            />

            {this.headerSlot && (
              <div class='p-6 pb-0'>
                <slot name='nest-modal-header'></slot>
              </div>
            )}

            {this.data?.title && (
              <div class='font-bold text-xl pl-6 pt-6 pr-14'>
                {this.data?.title}
              </div>
            )}

            <div class='p-6'>
              <slot></slot>
            </div>

            {this.footerSlot && (
              <div class='p-4 bg-gray-50 rounded-b'>
                <slot name='nest-modal-footer'></slot>
              </div>
            )}
          </div>
        </div>
      </Host>
    );
  }
}
